import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { getRouter } from '~/app/router'
import { capturePartnerFromUrl } from '~/shared/lib/partner-attribution'
import { ErrorBoundary } from '~/shared/ui/error-boundary'
import '~/shared/styles/styles.css'
import * as Sentry from '@sentry/react'
import { version } from '../package.json'
import { env } from './env'

Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  environment: env.VITE_ENV,
  release: `business-dashboard@${version}`,
  dist: 'web',
  debug: env.VITE_SENTRY_DEBUG_LOGS,
  enabled: !env.VITE_SENTRY_DISABLED,
  enableLogs: env.VITE_SENTRY_OPERATIONS_LOGS,
  tracesSampleRate: env.VITE_SENTRY_SAMPLE_RATE,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
  integrations: [Sentry.replayIntegration()],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

capturePartnerFromUrl(window.location.search)

const router = getRouter()
const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </StrictMode>,
)
